module.exports = __webpack_public_path__ + "img/Italian_Salad_Chicken.ec2f4da5.jpg";